module.exports = __webpack_public_path__ + "static/fishmeal-73dcee77471e687e8cde25fcd966f0b0.jpg";